'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unpublishedMessagesForThread = undefined;

var _reselect = require('reselect');

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getters = require('conversations-async-data/indexed-async-data/operators/getters');

var _getters2 = require('conversations-async-data/async-data/operators/getters');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _getters3 = require('conversations-schema/unpublished-messages/operators/getters');

var _getUnpublishedMessages = require('./getUnpublishedMessages');

var _threadFromProps = require('../../threads/selectors/threadFromProps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unpublishedMessagesForThread = exports.unpublishedMessagesForThread = (0, _reselect.createSelector)([_getUnpublishedMessages.getUnpublishedMessages, _threadFromProps.threadFromProps], function (unpublishedMessages, thread) {
  var threadId = (0, _threadGetters.getThreadId)(thread);

  var unpublishedMessagesForThreadId = (0, _getters.getEntries)(unpublishedMessages).filter(function (unpublishedMessageAsyncData) {
    var unpublishedMessageThreadId = (0, _pipe2.default)(_getters2.getData, _threadGetters.getThreadId)(unpublishedMessageAsyncData);

    return unpublishedMessageThreadId === threadId;
  });

  var messages = unpublishedMessagesForThreadId.map(_getters2.getData);

  var sortedUnpublishedMessages = messages.sort(function (unpublishedMessageA, unpublishedMessageB) {
    var messageA = (0, _getters3.getMessage)(unpublishedMessageA);
    var messageB = (0, _getters3.getMessage)(unpublishedMessageB);
    return (0, _commonMessageFormatGetters.getTimestamp)(messageA) - (0, _commonMessageFormatGetters.getTimestamp)(messageB);
  });

  return sortedUnpublishedMessages;
});